/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesPlayGameUnityGameConfigOptions interface.
 */
export function instanceOfFxIdWebFeaturesPlayGameUnityGameConfigOptions(value) {
    if (!('BaseUrl' in value) || value['BaseUrl'] === undefined)
        return false;
    if (!('BaseBuildUrl' in value) || value['BaseBuildUrl'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesPlayGameUnityGameConfigOptionsFromJSON(json) {
    return FxIdWebFeaturesPlayGameUnityGameConfigOptionsFromJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayGameUnityGameConfigOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'BaseUrl': json['BaseUrl'],
        'BaseBuildUrl': json['BaseBuildUrl'],
        'UnityBuildJson': json['UnityBuildJson'] == null ? undefined : json['UnityBuildJson'],
    };
}
export function FxIdWebFeaturesPlayGameUnityGameConfigOptionsToJSON(json) {
    return FxIdWebFeaturesPlayGameUnityGameConfigOptionsToJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayGameUnityGameConfigOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'BaseUrl': value['BaseUrl'],
        'BaseBuildUrl': value['BaseBuildUrl'],
        'UnityBuildJson': value['UnityBuildJson'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesPlayGameUnityGameConfigOptions.js.map